
import { FILTER_NOTICE } from "./Noticeboard";
import pluralize from "pluralize";
import { capitalizeString, customNames } from "src/utils/helpers";
import { SERVERLESS_IMAGE_HANDLER_URL, CONTENT_S3_BUCKET } from "src/scenes/App";
import { Buffer } from "buffer";
/**
 * Get title-case user type name for whom this notice is for: Employees, Clients or Users
 * @param notice - Notice object from API
 * @returns {string}
 */
export function userTypeTitleFromReaderTypes(notice) {
    const toEmployees = notice.publications.some(publication => publication.readerType === FILTER_NOTICE.EMPLOYEE);
    const toClients = notice.publications.some(publication => publication.readerType === FILTER_NOTICE.CLIENT);
    if (toEmployees && !toClients) {
        return `${capitalizeString(pluralize.singular(customNames.employees))}`;
    } else if (!toEmployees && toClients) {
        return `${capitalizeString(pluralize.singular(customNames.clients))}`;
    }
    return `${capitalizeString(pluralize.singular(customNames.employees))} & ${capitalizeString(pluralize.singular(customNames.clients))}`;
}


export function getAssetUrl(notice) {
    if (notice.postType === "image" && notice.image) {
        return getImageUrl(notice.image.imageKey); //will analyze in future diff how serverless image works
    }
    else if (notice.postType === "video" && notice.video) {
        return notice.video.videoUrl;
    }
    else if (notice.postType === "carousel" && notice.carousel) {
        return notice.carousel;
    }

    return null;
}

export const getImageUrl = (imageKey) => {
    // do transcoder stuff... generate a JSON object... base64 encode it... append that to the image.dailyfixme.com url
    // then use that url as the key for the <img> tag in the noticeboard class...
    let transcoderJsonObject = `{
        "bucket": "${CONTENT_S3_BUCKET}",
        "key": "${imageKey}"
    }`;

    const encodedString = Buffer.from(transcoderJsonObject).toString("base64");
    return (SERVERLESS_IMAGE_HANDLER_URL || "") + `/${encodedString}`;
};
